import PropTypes from 'prop-types';
import { useRef } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { AppBar, IconButton, Toolbar, Typography, useMediaQuery } from '@mui/material';

// project import
import AppBarStyled from './AppBarStyled';
import HeaderContent from './HeaderContent';

// assets
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { ChevronLeft } from 'lucide-react';

// App imports
// import Notification from 'components/@ui/notification/Notification-popper';
import { useDispatch, useSelector } from 'react-redux';
import { toggleDrawerHoverable } from 'store/reducers/menu';
// import SpringPopper from 'components/@ui/notification/pop';

import clsx from 'clsx';

// ==============================|| MAIN LAYOUT - HEADER ||============================== //

const Header = ({ open, handleDrawerToggle }) => {
  const theme = useTheme();
  const matchDownMD = useMediaQuery(theme.breakpoints.down('lg'));
  const dispatch = useDispatch();
  const { drawerHoverable } = useSelector((state) => state.menu);

  const iconBackColor = 'pink';
  const iconBackColorOpen = 'red';

  const notificationRef = useRef(null);

  const handleClick = (event) => {
    dispatch(toggleDrawerHoverable());
    handleDrawerToggle();
  };

  // common header
  const mainHeader = (
    <>
      {' '}
      <Toolbar ref={notificationRef} className="relative">
        <IconButton
          disableRipple
          aria-label="open drawer"
          onClick={handleClick}
          edge="start"
          color="secondary"
          sx={{ color: 'text.primary', backgroundColor: open ? iconBackColorOpen : iconBackColor, ml: { xs: 0, lg: -2 } }}
          className="border"
        >
          {!open ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
          {/* <div className="w-full h-full bg-grey-100 flex items-center justify-center rounded p-2"> */}
          {/* <ChevronLeft className={clsx(!open ? 'rotate-180' : '', 'transition-all duration-150 ease-in-out', 'w-14 h-14')} /> */}
          {/* </div> */}
        </IconButton>
        <Typography className="w-full font-semibold text-md">{sessionStorage.getItem('organization') || ''}</Typography>
        <HeaderContent />

        {/* <SpringPopper /> */}
      </Toolbar>
      {/* <Notification ref={notificationRef} /> */}
    </>
  );

  // app-bar params
  const appBar = {
    position: 'fixed',
    color: 'inherit',
    elevation: 0,
    sx: {
      borderBottom: `1px solid ${theme.palette.divider}`
      // boxShadow: theme.customShadows.z1
    }
  };

  return (
    <>
      {!matchDownMD ? (
        <AppBarStyled open={open} {...appBar}>
          {mainHeader}
        </AppBarStyled>
      ) : (
        <AppBar {...appBar}>{mainHeader}</AppBar>
      )}
    </>
  );
};

Header.propTypes = {
  open: PropTypes.bool,
  handleDrawerToggle: PropTypes.func
};

export default Header;
